import { api, apiUrls } from "../../../utils/api";
import { translate } from "../../../utils/translate";
import { Popup, AsyncHelper } from "@bryntum/gantt";

export async function JoinProject(currentProjectId, connectionId) {
  const resp = await api.post(apiUrls.JoinProject, {
    currentProject: currentProjectId,
    connectionid: connectionId,
  });
  return resp.json();
}

export async function LeaveProject(currentProjectId, connectionId) {
  await api.post(apiUrls.LeaveProject, {
    currentProject: currentProjectId,
    connectionid: connectionId,
  });
}

export const unsavedChangesPopup = (msg) => {
  return new Promise((resolve) => {
    let ignore = false;
    let save = false;
    const popup = new Popup({
      width: 500,
      title: translate("unsavedTitle"),
      modal: {
        closeOnMaskTap: true,
      },
      centered: true,
      closeAction: "destroy",
      closable: true,
      focusOnToFront: false,
      trapFocus: false,
      content: `<div style='width:100%;margin-bottom: 20px'>${msg}</div>`,
      onBeforeClose: () => {
        resolve({
          ignore,
          cancel: !(ignore || save),
          save,
        });
      },
      bbar: [
        {
          type: "button",
          text: translate("unsavedIgnore"),
          style: "min-width: 30%",
          color: "b-raised",
          onClick: () => {
            ignore = true;
            popup.close();
          },
        },
        {
          type: "button",
          text: translate("unsavedSave"),
          style: "min-width: 30%",
          ref: "saveButton",
          color: "b-raised",
          onClick: () => {
            save = true;
            popup.close();
          },
        },
      ],
    });
  });
};

/**
 * @param abort {AbortController}
 * @returns {Promise<unknown>}
 */
export function beforeRefreshPopup(abort) {
  return new Promise((resolve, reject) => {
    let ignore = true;
    abort.signal.addEventListener("abort", () => {
      reject();
      popup.close && popup.close();
    });
    const popup = new Popup({
      maxWidth: 750,
      title: translate("refreshDialogAlertTitle"),
      modal: {
        closeOnMaskTap: true,
      },
      centered: true,
      closeAction: "destroy",
      closable: true,
      content: `<div style='width:100%;margin-bottom: 20px'>${translate("refreshDialogAlertContent")}</div>`,
      onBeforeClose: () => {
        if (ignore) {
          reject();
        }
        resolve();
      },
      bbar: [
        {
          type: "button",
          text: translate("Cancel"),
          style: "min-width: 30%",
          color: "b-raised",
          onClick: () => {
            ignore = true;
            popup.close();
          },
        },
        {
          type: "button",
          ref: "saveButton",
          text: translate("Continue"),
          style: "min-width: 30%",
          color: "b-raised",
          onClick: () => {
            ignore = false;
            popup.close();
          },
        },
      ],
    });
  });
}
